import gql from 'graphql-tag';

export default gql`
  mutation deleteUserGroupRole($id: UUID!) {
    deleteUserGroupRole(_id: $id)
  }
`;
